import { useState, type FormEvent } from "react";
import { api, type PublicUser } from "../../lib/api";

export function LoginPage({ onSuccess }: { onSuccess: (u: PublicUser) => void }) {
  const [email, setEmail] = useState("admin@localhost");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [challengeToken, setChallengeToken] = useState<string | null>(null);
  const [challengeEmail, setChallengeEmail] = useState("");
  const [otp, setOtp] = useState("");

  async function submitPassword(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await api.login(email.trim(), password);
      if ("requires2fa" in res && res.requires2fa) {
        setChallengeToken(res.challengeToken);
        setChallengeEmail(res.email);
        setOtp("");
        return;
      }
      if ("user" in res && res.user) onSuccess(res.user);
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Login failed";
      if (/unauthorized/i.test(msg)) {
        setError(
          "Sessione non salvata dal browser (tipico di Fulguris / anti-tracciamento). Consenti i cookie per box.wiumail.com, oppure disattiva la protezione avanzata su questo sito, poi riprova.",
        );
      } else if (/failed to fetch/i.test(msg)) {
        setError("Connessione API fallita. Ricarica https://box.wiumail.com/login/");
      } else {
        setError(msg);
      }
    } finally {
      setLoading(false);
    }
  }

  async function submitOtp(e: FormEvent) {
    e.preventDefault();
    if (!challengeToken) return;
    setLoading(true);
    setError("");
    try {
      const res = await api.login2fa(challengeToken, otp.trim());
      onSuccess(res.user);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Codice non valido");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-stage" aria-hidden>
        <div className="auth-orb auth-orb-a" />
        <div className="auth-orb auth-orb-b" />
        <div className="auth-grid" />
      </div>
      <div className="auth-card">
        <div className="brand brand-lg">
          <span className="brand-mark">M</span>
          <div className="brand-text">
            <strong>Mailstorm</strong>
            <em>Webmail multi-account</em>
          </div>
        </div>
        {challengeToken ? (
          <>
            <h1>Verifica 2FA</h1>
            <p className="auth-lead">
              Inserisci il codice a 6 cifre dall’app Authenticator per{" "}
              <strong>{challengeEmail}</strong>, oppure un codice di recupero.
            </p>
            <form className="form" onSubmit={(e) => void submitOtp(e)}>
              <div>
                <label className="label" htmlFor="otp">
                  Codice Authenticator
                </label>
                <input
                  id="otp"
                  className="input"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  autoComplete="one-time-code"
                  inputMode="numeric"
                  placeholder="123456"
                  required
                  autoFocus
                />
              </div>
              <div className="error">{error}</div>
              <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
                {loading ? "Verifica…" : "Conferma accesso"}
              </button>
              <button
                className="btn btn-block"
                type="button"
                disabled={loading}
                onClick={() => {
                  setChallengeToken(null);
                  setOtp("");
                  setError("");
                }}
              >
                Torna al login
              </button>
            </form>
          </>
        ) : (
          <>
            <h1>Accedi</h1>
            <p className="auth-lead">
              Un client professionale per Gmail, Microsoft e IMAP — stile SnappyMail / Roundcube Elastic.
            </p>
            <form className="form" onSubmit={(e) => void submitPassword(e)}>
              <div>
                <label className="label" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>
              <div>
                <label className="label" htmlFor="password">
                  Password
                </label>
                <input
                  id="password"
                  className="input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </div>
              <div className="error">{error}</div>
              <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
                {loading ? "Accesso…" : "Entra in Mailstorm"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
